import React from "react";
import "./Footer.css";

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p className="footer__tagline">
          <strong>Academia Rafael Toro</strong> Acelere sua carreira. E agora,
          sua garagem também!
        </p>

        <div className="footer__legal">
          <p>
            Razão Social: RAFAEL TORO ACADEMIA DE FINANCAS LTDA. | CNPJ:
            30.425.807/0001-37
          </p>
          <p>
            Razão Social: TORO &amp; SANTI PARTICIPAÇÕES LTDA. | CNPJ:
            52.039.334/0001-72
          </p>
          <p>Promoção válida de 16/07/2026 a 07/12/2026.</p>
          <p>Sorteio pela Loteria Federal.</p>
        </div>
      </div>
    </footer>
  );
}
